
























































import { Component, Prop, Vue } from "vue-property-decorator";

import DxLoadIndicator from "devextreme-vue/load-indicator";
import DxForm, {
  DxItem,
  DxEmailRule,
  DxRequiredRule,
  DxLabel,
  DxButtonItem,
  DxButtonOptions,
} from "devextreme-vue/form";
import DxButton from "devextreme-vue/button";
import notify from "devextreme/ui/notify";
import { Login } from "@/shared/dtos/login";
import { RouterNames } from "@/router/routernames";

@Component({
  components: {
    DxForm,
    DxItem,
    DxEmailRule,
    DxRequiredRule,
    DxLabel,
    DxButtonItem,
    DxButtonOptions,
    DxButton,
    DxLoadIndicator,
  },
})
export default class LoginForm extends Vue {
  @Prop() resetLink?: string;
  @Prop() createAccountLink?: string;

  /*async onSubmit() {
    const { email, password } = this.formData;
    
  const result = await auth.logIn(email, password);
  if (!result.isOk) {
    loading.value = false;
    notify(result.message, 'error', 2000);
  } else {
    router.push('/');
  }
  }*/

  public appTitle = process.env.VUE_APP_TITLE;

  public login = new Login();
  public hide: boolean = true;
  public show_modal: boolean = false;
  public loading = false;

  public mounted() {
    this.login = new Login();
    this.login.UserName = "";
    this.login.Pwd = "";
    setTimeout(() => (this.hide = false), 1);
  }

  public onSubmit() {
    /*this.$validator.validateAll().then((allOk) => {    });
      if (allOk) {}*/
    this.tryLogin();
  }

  public async tryLogin() {
    this.loading = true;
    const authorizationService = await import(
      "@/shared/services/AuthorizationService"
    );
    authorizationService.authorizationService
      .login(this.login)
      .then(this.loginResult.bind(this))
      .catch(() => {
        this.loading = false;
      });
  }

  private async loginResult(loginOk: Login) {
    if (loginOk.Success) {
      this.hide = true;
      this.loading = true;
      setTimeout(() => this.routeToMain(), 250);
    } else {
      notify("Usuario o Clave incorrectos", "error", 2000);
      this.loading = false;
    }
  }

  private routeToMain() {
    this.$router.push({ name: RouterNames.mainlayout });
  }
}
